import { useMediaQuery } from "@mui/material";
import { MOBILE_BREAKPOINT_PX } from "../Config/uiConfig";

export function useIsMobile(): boolean {
  return useMediaQuery(`(max-width:${MOBILE_BREAKPOINT_PX}px)`);
}
